export default __webpack_public_path__ + "static/media/archive.2fb65218.svg";